import React, { useState } from 'react';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth'; // Firebase Auth
import { doc, setDoc } from 'firebase/firestore'; // Firestore methods
import { db } from '../firebase'; // Firestore instance
import './Signup.css'; // Add styles for the signup page

function Signup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    company: '',
    accessCode: '', // Add access code to form data
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    const auth = getAuth();

    // Validate access code
    if (formData.accessCode !== '5262') {
      setError('Invalid access code. Please try again.');
      setSuccess('');
      return;
    }

    try {
      // Create user with Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      const user = userCredential.user;

      // Save user data to Firestore
      const userDocRef = doc(db, 'users', user.uid);
      await setDoc(userDocRef, {
        name: formData.name,
        email: formData.email,
        company: formData.company,
      });

      setSuccess('User created successfully!');
      setError('');
      setFormData({ name: '', email: '', password: '', company: '', accessCode: '' }); // Reset form
    } catch (err) {
      console.error('Error signing up:', err);
      setError(err.message);
      setSuccess('');
    }
  };

  return (
    <div className="signup-container">
      <h1 className="signup">Signup</h1>
      <form onSubmit={handleSignup} className="signup-form">
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="company"
          placeholder="Company"
          value={formData.company}
          onChange={handleInputChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="accessCode"
          placeholder="Access Code"
          value={formData.accessCode}
          onChange={handleInputChange}
          required
        />
        <button type="submit" className="signup-button">
          Signup
        </button>
      </form>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
    </div>
  );
}

export default Signup;